// test775
(775 && 0);
